import { render, staticRenderFns } from "./ManageOrganisation.vue?vue&type=template&id=29bcd8f0&"
import script from "./ManageOrganisation.vue?vue&type=script&lang=ts&"
export * from "./ManageOrganisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab})
